var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbcdCarInsuranceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000244141,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F1F3F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99976L23 13.9998H25C26.11 13.9998 27 14.8898 27 15.9998V18.9998H25C25 19.7954 24.6839 20.5585 24.1213 21.1211C23.5587 21.6837 22.7956 21.9998 22 21.9998C21.2044 21.9998 20.4413 21.6837 19.8787 21.1211C19.3161 20.5585 19 19.7954 19 18.9998H13C13 19.7954 12.6839 20.5585 12.1213 21.1211C11.5587 21.6837 10.7956 21.9998 10 21.9998C9.20435 21.9998 8.44129 21.6837 7.87868 21.1211C7.31607 20.5585 7 19.7954 7 18.9998H5V15.9998C5 14.8898 5.89 13.9998 7 13.9998L10 9.99976H20ZM14.5 11.4998H10.75L8.86 13.9998H14.5V11.4998ZM16 11.4998V13.9998H21.14L19.25 11.4998H16ZM10 17.4998C9.60218 17.4998 9.22064 17.6578 8.93934 17.9391C8.65804 18.2204 8.5 18.6019 8.5 18.9998C8.5 19.3976 8.65804 19.7791 8.93934 20.0604C9.22064 20.3417 9.60218 20.4998 10 20.4998C10.3978 20.4998 10.7794 20.3417 11.0607 20.0604C11.342 19.7791 11.5 19.3976 11.5 18.9998C11.5 18.6019 11.342 18.2204 11.0607 17.9391C10.7794 17.6578 10.3978 17.4998 10 17.4998ZM22 17.4998C21.6022 17.4998 21.2206 17.6578 20.9393 17.9391C20.658 18.2204 20.5 18.6019 20.5 18.9998C20.5 19.3976 20.658 19.7791 20.9393 20.0604C21.2206 20.3417 21.6022 20.4998 22 20.4998C22.3978 20.4998 22.7794 20.3417 23.0607 20.0604C23.342 19.7791 23.5 19.3976 23.5 18.9998C23.5 18.6019 23.342 18.2204 23.0607 17.9391C22.7794 17.6578 22.3978 17.4998 22 17.4998Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcdCarInsuranceIcon);
export default __webpack_public_path__ + "static/media/abcd-car-insurance-icon.313559f33619c8aee53d0b6af64c37d5.svg";
export { ForwardRef as ReactComponent };